"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HyperwalletInformation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const transformToDate_1 = require("../transformers/transformToDate");
let HyperwalletInformation = class HyperwalletInformation {
    token;
    createdOn;
    verificationStatus;
    profileType;
    taxVerificationStatus;
    status;
    latestWebhookNotificationDate;
};
exports.HyperwalletInformation = HyperwalletInformation;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HyperwalletInformation.prototype, "token", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], HyperwalletInformation.prototype, "createdOn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HyperwalletInformation.prototype, "verificationStatus", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HyperwalletInformation.prototype, "profileType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HyperwalletInformation.prototype, "taxVerificationStatus", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HyperwalletInformation.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], HyperwalletInformation.prototype, "latestWebhookNotificationDate", void 0);
exports.HyperwalletInformation = HyperwalletInformation = __decorate([
    (0, class_transformer_1.Exclude)()
], HyperwalletInformation);
//# sourceMappingURL=HyperwalletInformation.js.map